import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import SamplesModelDialog from "./SamplesModelDialog.vue";
import jslinq from "jslinq";
import hideMobileKeyboardOnReturn from "../plugins/utils";
import ItemsCarousel from "@/components/ItemsCarousel.vue";
import config from "@/config/custom-config";
let ColoriFrontali = class ColoriFrontali extends Vue {
  constructor() {
    super(...arguments);
    this.defaultColor = null;
    this.itemsType = "coloriFrontali";
    this.noImageColor = [];
    this.ecoColors = false;
    this.searchQuery = "";
    this.category = [];
    this.animateColors = false;
    this.hoverWarning = false;
    this.showSampleDialog = false;
    this.selectedFinishings = "";
    this.giacWarning = false;
    this.giacWarningMessage = "";
    this.scrolling = false;
    this.showLeftButton = false;
    this.showRightButton = false;
    this.scrollCounter = 0;
    this.finituraOptions = [];
    this.filtroColori = "";
    this.filtriColori = [{
      nome: "Rosa",
      max: 345,
      min: 300
    }, {
      nome: "Viola",
      max: 299,
      min: 239
    }, {
      nome: "Blu",
      max: 238,
      min: 190
    }, {
      nome: "Verde",
      max: 189,
      min: 75
    }, {
      nome: "Giallo",
      max: 74,
      min: 48
    }, {
      nome: "Arancione",
      max: 47,
      min: 14
    }, {
      nome: "Rosso",
      max: 13,
      min: 0
    }, {
      nome: "Nero e Bianco",
      max: -1,
      min: -2
    }];
  }
  async mounted() {
    await this.getColors();
    this.finituraOptions = [{
      id: "S",
      text: 'Lucido'
    }, {
      id: "M",
      text: 'Opaco'
    }];
  }
  hideMobileKeyboardOnReturn(e) {
    hideMobileKeyboardOnReturn(e);
  }
  get config() {
    return config;
  }
  get filteredTemples() {
    return this.$store.state.filteredTemples;
  }
  get categories() {
    return jslinq(this.colori).select(c => _.capitalize(c.Category.toLowerCase())).distinct().toList();
  }
  get tintaUnita() {
    return this.$store.state.tintaUnita;
  }
  set tintaUnita(newVal) {
    this.$store.commit("setTintaUnita", newVal);
  }
  get filteredColors() {
    let q = this.searchQuery;
    let c = this.category;
    let f = this.filtroColori;
    let result = this.colori;
    if (q) {
      result = result.filter(color => {
        return _.includes(color === null || color === void 0 ? void 0 : color.PLASTICA, q);
      });
    }
    if (f) {
      result = result.filter(color => {
        return color.Order <= f.max && color.Order >= f.min;
      });
    }
    if (!_.isEmpty(c)) {
      if (result) {
        result = result.filter(color => {
          // confronta la categoria capitalizzata (prima lettera maiuscola, resto minuscolo)
          const cat = _.capitalize(color === null || color === void 0 ? void 0 : color.Category.toLowerCase());
          return c.includes(cat);
        });
      }
    }
    if (this.ecoColors) {
      result = result.filter(color => {
        return color.U_THE_COLORE.indexOf("EP") >= 0;
      });
    }
    if (this.tintaUnita) {
      result = result.filter(color => {
        return this.filteredTemples.some(t => {
          return t.U_THE_COLORE === color.U_THE_COLORE;
        });
      });
    }
    return _.difference(result, this.noImageColor);
  }
  get temples() {
    const aste = this.$store.state.configurator.aste.allColors;
    return aste;
  }
  set temples(newVal) {
    this.$store.commit("configurator/aste/setAllColors", newVal);
  }
  get finitura() {
    return this.$store.state.configurator.finitura;
  }
  set finitura(newVal) {
    this.finishing = newVal;
  }
  get finishing() {
    if (this.finitura) {
      return this.finitura;
    } else {
      return "S";
    }
  }
  set finishing(f) {
    this.$store.commit("configurator/setFinishing", f);
    if (this.tintaUnita) {
      this.$store.commit("configurator/setTemplesFinishing", f);
    }
  }
  get colore() {
    return this.$store.state.configurator.colore.U_THE_COLORE;
  }
  get color() {
    return this.$store.state.configurator.colore.U_THE_COLORE;
  }
  get finituraAste() {
    return this.$store.state.configurator.finituraAste;
  }
  get frontale() {
    return this.$store.state.configurator.frontale;
  }
  get coloreActive() {
    const colore = this.$store.state.configurator.colore;
    if (colore) {
      return colore.ItemCode;
    } else {
      console.warn("frontale is null or undefined");
      return null;
    }
  }
  set colore(c) {
    if (parseInt(c.GiacIta) < 1) {
      this.giacWarning = true;
      this.giacWarningMessage = this.$t('message.Il_colore_{color}_è_esaurito,_data_di_arrivo:_{date}', {
        color: c.U_THE_COLORE,
        date: this.formatDate(new Date(c.ShipDateIta))
      }).toString();
    }
    this.$store.commit("configurator/setColore", c);
  }
  get colori() {
    return this.$store.state.configurator.frontali.colors;
  }
  get canOrderColorSample() {
    return this.$store.getters["canOrderColorSample"];
  }
  get coloreAste() {
    return this.$store.state.configurator.coloreAste;
  }
  formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  getColors() {
    return this.$store.dispatch("configurator/frontali/getColors");
  }
  coloreSelected(col) {
    if (parseInt(col.GiacIta) < 1 && !col.ShipDateIta) {
      return;
    }
    if (this.tintaUnita) {
      let corresponding = null;
      corresponding = this.filteredTemples.find(temple => {
        console.log("temple", temple.U_THE_COLORE, "colore", col.U_THE_COLORE);
        return temple.U_THE_COLORE == col.U_THE_COLORE;
      });
      if (corresponding) {
        this.$store.commit("configurator/setTemplesColor", corresponding);
        this.$store.commit("configurator/setTemplesFinishing", this.finitura);
      }
    }
    this.colore = col;
  }
  colorImageUrl(colore) {
    if (colore && colore.Category != "MULTISTRATO") {
      return colore.imageUrl;
    }
    if (colore) {
      return colore.imageUrl;
    }
    return "";
  }
  removeChip(item) {
    const index = this.category.indexOf(item);
    if (index !== -1) {
      this.category.splice(index, 1);
    }
  }
  isActive(c) {
    return this.colore == c;
  }
  removeCategoryItem(item) {
    _.pull(this.category, item);
  }
  noImageError(c) {
    this.noImageColor.push(c);
  }
  loadImageUrl(w) {
    let e = w.el;
    let src = w.el.dataset.src;
    if (w.going.toLowerCase() === "in") {
      e.src = src;
    }
  }
  onRevealSettingChanged(newVal) {
    if (newVal == "frontColor") {
      let self = this;
      this.animateColors = true;
      setTimeout(function () {
        self.animateColors = false;
        self.$emit("reset-setting-item");
      }, 2000);
    }
  }
  onTintaUnitaChanged(newVal) {
    if (newVal) {
      if (this.finituraAste != this.finitura) {
        this.finitura = this.finituraAste;
      }
    }
  }
};
__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "darkTheme", void 0);
__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "isOpen", void 0);
__decorate([Prop({
  default: false
})], ColoriFrontali.prototype, "revealSetting", void 0);
__decorate([Watch("revealSetting")], ColoriFrontali.prototype, "onRevealSettingChanged", null);
__decorate([Watch("tintaUnita")], ColoriFrontali.prototype, "onTintaUnitaChanged", null);
ColoriFrontali = __decorate([Component({
  components: {
    SamplesModelDialog,
    ItemsCarousel
  },
  filters: {
    upper(val) {
      return _.upperCase(val);
    },
    capitalize: str => {
      return _.capitalize(str);
    }
  }
})], ColoriFrontali);
export default ColoriFrontali;